<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Központi Árlisták</span>
      <el-button
        v-can="'customerpricelist.create'"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="$router.replace('/data/customer-price-lists/add')"
      >
        Új központi árlista
      </el-button>
      <el-button
        v-can="'customerpricelist.view'"
        style="float: right; margin-top: -5px; margin-right: 5px"
        size="small"
        @click="$router.replace('/data/customer-price-lists/product-prices')"
      >
        Alapértelmezett árak
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="customerPriceList/fetchAll"
      />
    </div>
    <customer-price-lists-list style="min-height: 100px;" />
    <template v-if="$route.meta.showAddCustomerPriceListDialog">
      <customer-price-list-dialog
        type="add"
        :copy-from-id="$route.params.id || null"
      />
    </template>
    <template v-if="$route.meta.showUpdateCustomerPriceListDialog">
      <customer-price-list-dialog
        :customer-price-list-id="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showProductPricesDialog">
      <product-price-dialog />
    </template>
  </el-card>
</template>

<script>
  import CustomerPriceListsList from '../../components/data/customerPriceLists/List';
  import CustomerPriceListDialog from '../../components/data/customerPriceLists/Dialog';
  import TableFilter from '../../components/TableFilter';
  import ProductPriceDialog from '../../components/data/customerPriceLists/productPrices/Dialog';

  export default {
    components: {
      CustomerPriceListsList,
      CustomerPriceListDialog,
      TableFilter,
      ProductPriceDialog
    },
    data() {
      return {
        filterConfig: null,
        loading: false,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {

        this.filterConfig = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true,
          },
          {
            type: 'select',
            name: 'is_valid',
            options: [
              {
                label: 'Igen',
                valid: 1
              },
              {
                label: 'Nem',
                valid: 0,
              },
            ],
            label: 'Érvényes',
            labelCallback: isValid => isValid.label,
            valueKey: 'valid',
          },
        ];
      },
    },
  };
</script>
